import React, { useState, useEffect, useContext, useRef } from "react";
import "./Faq_Banner.css";
import { Accordion } from "react-bootstrap";
import { Faqs } from "../../../utils/apis/faq/Faq";
import ScrollToTop from "../../scrolltotop/ScrollToTop";

const Faq_Banner = () => {
  // const [activeTab, setActiveTab] = useState("Consumer Registration");

  const faqData = {
    "Consumer Registration": [
      {
        question: "Q1. Who can register as a consumer?",
        answer:
          "Any electricity consumer with a valid consumer account number can register on the portal.",
      },
      {
        question: "Q2. What details are required for registration?",
        answer:
          "Basic consumer details, account number, mobile number and email.",
      },
      {
        question: "Q3. Is registration free of cost?",
        answer: "Yes, registration on the portal is completely free.",
      },
      {
        question: "Q4. Can I register without a consumer account number?",
        answer: "No, a valid consumer account number is mandatory.",
      },
      {
        question: "Q5. Who can register as a consumer?",
        answer:
          "Any electricity consumer with a valid consumer account number can register on the portal.",
      },
      {
        question: "Q6. What details are required for registration?",
        answer:
          "Basic consumer details, account number, mobile number and email.",
      },
      {
        question: "Q7. Is registration free of cost?",
        answer: "Yes, registration on the portal is completely free.",
      },
      {
        question: "Q8. Can I register without a consumer account number?",
        answer: "No, a valid consumer account number is mandatory.",
      },
    ],

    "Application Process": [
      {
        question: "Q1. How do I apply for installation?",
        answer: "Login to your account and submit the application form.",
      },
      {
        question: "Q2. How long does approval take?",
        answer: "Approval usually takes 7-10 working days.",
      },
    ],

    "Vendor Selection": [
      {
        question: "Q1. How do I choose a vendor?",
        answer: "You can select from empanelled vendors listed on the portal.",
      },
    ],

    "Documents & Uploads": [
      {
        question: "Q1. What documents are required?",
        answer: "ID proof, electricity bill and property documents.",
      },
    ],

    "Installation & Inspection": [
      {
        question: "Q1. Who performs the inspection?",
        answer: "Inspection is carried out by the authorized DISCOM official.",
      },
    ],

    "Subsidy & Payments": [
      {
        question: "Q1. When will I receive subsidy?",
        answer:
          "Subsidy is credited to your bank account after successful inspection.",
      },
    ],
  };
  const contentRef = useRef(null);
  const [faq, setFaq] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const getFaq = async () => {
    const res = await Faqs();

    if (res?.success) {
      const data = res?.data?.data || [];

      setFaq(data);

      // set first category active
      if (data.length > 0) {
        setActiveTab(data[0]?.FAQCategory?.name);
      }
    }
  };

  useEffect(() => {
    getFaq();
  }, []);

  // Extract unique categories
  const categories = [...new Set(faq.map((item) => item?.FAQCategory?.name))];

  // Filter questions based on selected category
  const filteredFaq = faq.filter(
    (item) => item?.FAQCategory?.name === activeTab,
  );

  return (
    <>
      

      <section className="Faq_Banner">
        <div className="container-fluid">
          {/* Banner */}
          <div className="Faq_Banner_holder">
            <img
              src="/assets/images/faq/faq-banner.png"
              className="Faq_img"
              alt="FAQ Banner"
            />
          </div>

          <div className="faq_wrapper">
            {/* LEFT SIDEBAR */}
            <div className="faq_sidebar">
              <h4 className="faq_title">Your questions, Answered simply.</h4>

              {categories.map((category, index) => (
                <div
                  key={index}
                  className={`faq_tab ${
                    activeTab === category ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab(category);

                    contentRef.current?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                >
                  {category}
                </div>
              ))}
            </div>

            {/* RIGHT ACCORDION */}
            <div className="faq_content" ref={contentRef}>
              <Accordion defaultActiveKey="0" key={activeTab}>
                {filteredFaq.map((item, index) => (
                  <Accordion.Item eventKey={index.toString()} key={item.id}>
                    <Accordion.Header>
                      {index + 1}
                      {") "}
                      {item.question}
                    </Accordion.Header>

                    <Accordion.Body>{item.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq_Banner;
